<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">订单需求</div>
				<div class="menuItem">参考照片</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="orderList" v-if="orderList.length">
				<div class="orderItem" v-for="(item,index) in orderList" :key="index">
					<div class="orderItemTop">
						<div class="timeNoDetails">
							<div class="time">{{item.create_time}}</div>
							<div class="no">订单号: {{item.order_sn}}</div>
							<div class="details" @click="naviToDetails(item)">订单详情<img class="arrow"
									src="../assets/MyOrder/iconD.png" /></div>
							<div class="details" style="color: #706614;"
								@click="curOrder = item;dialogEvaluateVisible = true" v-if="item.status == 4">
								{{item.pj_status == '' ? '去评价' : '查看评价'}}<img class="arrow"
									src="../assets/MyOrder/iconG.png" />
							</div>
						</div>
						<div class="countdownStatus">
							<div class="status">{{getStatusName(item)}}</div>
						</div>
					</div>
					<div class="orderItemBottom">
						<div class="checkImgGoodsInfoBox">
							<div class="goodsInfoBox">
								<div class="goodsInfo">
									<div class="goodsDesc">123123123</div>
									<div class="tips">
										<div class="tip">装饰画</div>
									</div>
								</div>
							</div>
						</div>
						<div class="image-gallery">
							<ImgAallery :images="item.img" v-if="item.img && item.img.length" />
						</div>
						<div class="operation">
							<div class="download" v-if="item.status == 4">下载图片</div>
							<div class="apply" v-if="item.status == 4 && item.invoice == 0" @click="applyInvoice(item)">
								<img src="../assets/MyOrder/iconB.png">
								申请发票
							</div>
							<div class="payNow" v-if="item.status == 2" @click="patOrder(item)">立即支付</div>
							<div class="cancel" v-if="item.status == 1 || item.status == 2" @click="cancelOrder(item)">
								取消订单</div>
							<div class="delete" v-if="item.status == 5" @click="deleteOrder(item)">删除</div>
						</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination style="padding: .2rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body
			@close="dialogReportVisible = false">
			<div slot="title">
				<div class="dislogTitle">
					物流信息
				</div>
			</div>
			<div class="dislogConent">
				<div>快递名称：{{}}</div>
				<div>快递单号：{{}}</div>
				<div>备注信息：{{}}</div>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain size="medium" @click="dialogReportVisible = false">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					支付二维码
				</div>
			</div>
			<div class="dislogConent">
				<img :src="payUrl" style="width: 2rem;height: 2rem;" />
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain size="medium" @click="dialogReportVisible = false">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<EvaluateDialog :show="dialogEvaluateVisible" @close="dialogEvaluateVisible = false" :orderData="curOrder">
		</EvaluateDialog>
		<ApplyInvoiceDialog :show="dialogApplyInvoiceViable" :type="3" :orderData="curOrder"
			@close="dialogApplyInvoiceViable = false" @update="sucPop = true;makeOrder()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'" @clickOk="sucPop = false"
			v-if="sucPop" />
	</div>
</template>

<script>
	import QRCode from 'qrcode';
	import PopToast from '../components/PopToast.vue'
	import ImgAallery from '../components/ImgAallery.vue'
	import EvaluateDialog from '../components/EvaluateDialog.vue'
	import ApplyInvoiceDialog from '../../src/components/ApplyInvoiceDialog.vue'

	export default {
		components: {
			PopToast,
			ImgAallery,
			EvaluateDialog,
			ApplyInvoiceDialog
		},
		data() {
			return {
				dialogEvaluateVisible: false,
				orderId: '',
				timer: null,
				payUrl: '',
				images: [
					'http://haisenlinmeifa.oss-cn-qingdao.aliyuncs.com/upload/e5a424bfcb87e6a7df3bedd2d5b4578a.jpg',
					'https://img1.baidu.com/it/u=2172818577,3783888802&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1422',
					'https://img1.baidu.com/it/u=1791653389,599136142&fm=253&fmt=auto&app=120&f=JPEG?w=800&h=960',
					'https://img1.baidu.com/it/u=600722015,3838115472&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=750',
					'https://img1.baidu.com/it/u=553043905,2597233655&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=750',
					'https://img0.baidu.com/it/u=410223476,4138599093&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=750',
					'https://img2.baidu.com/it/u=2612741288,182099192&fm=253&fmt=auto&app=138&f=JPEG?w=513&h=500',
				],
				orderList: [],
				// 分类导航
				categories: [{
						key: '0',
						name: '全部'
					},
					{
						key: '1',
						name: '画师待确认'
					},
					{
						key: '2',
						name: '待支付'
					},
					{
						key: '3',
						name: '创作中'
					},
					{
						key: '4',
						name: '已完成'
					},
					{
						key: '5',
						name: '已取消'
					}
				],
				curOrder: {},
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				scrollPosition: 0,
				thumbnailsPerPage: 3,
				activeCategory: '0',
				sucPop: false,
				dialogApplyInvoiceViable: false,
				dialogReportVisible: false,
				deadline4: Date.now() + (new Date().setHours(23, 59, 59) - Date.now()),
			}
		},
		mounted() {
			this.makeOrder()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.makeOrder()
			},
			//申请发票
			applyInvoice(item) {
				this.curOrder = item
				this.dialogApplyInvoiceViable = true
			},
			getStatusName(item) {
				if (item.status == 1) {
					return '画师待确认'
				} else if (item.status == 2) {
					return '待支付'
				} else if (item.status == 3) {
					return '创作中'
				} else if (item.status == 4) {
					return '已完成'
				} else if (item.status == 5) {
					return '已取消'
				}
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 2,
						orderId: item.id
					}
				})
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.makeOrder()
			},
			makeOrder() {
				this.$api.post('/Hua/dz_order_list', {
					status: this.activeCategory,
					p: this.currentPage
				}).then(res => {
					if (res.code == 1) {
						this.orderList = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//取消订单
			cancelOrder(item) {
				this.$confirm('确认取消当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/dz_order_cancel', {
						id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.makeOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//删除订单
			deleteOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/dz_order_del', {
						id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.makeOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			patOrder(item) {
				this.submitOrder(item.id)
			},
			submitOrder(orderId) {
				this.$api.post('/Tonglian/dz_nativepay', {
					id: orderId,
				}).then(res => {
					if (res.code == 1) {
						this.orderId = orderId
						this.generateQRCode(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			generateQRCode(text) {
				let that = this
				QRCode.toDataURL(text, function(error, url) {
					that.payUrl = url
					that.dialogReportVisible = true
					that.timer = setInterval(() => {
						that.checkOrder()
					}, 5000)
				});
			},
			checkOrder() {
				this.$api.post('/Notify/check_order', {
					order_id: this.orderId,
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.dialogReportVisible = false
						this.$message.success(res.msg)
						clearInterval(this.timer);
						this.timer = null
						//去订单列表
					}
				}).catch(err => {
					console.log(err);
				})
			},
			handleClose() {
				this.dialogReportVisible = false
				clearInterval(this.timer);
				this.timer = null
			},
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: 4rem;
			}

			.menuItem:nth-child(2) {
				width: 3.55rem;
			}

			.menuItem:nth-child(3) {
				width: 1.2rem;
			}
		}

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;

			.orderItem {
				display: flex;
				flex-direction: column;

				.orderItemTop {
					height: .4rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 .16rem;
					background: #FAEFDD;
					border-radius: .04rem;

					.timeNoDetails {
						display: flex;
						align-items: center;

						.time,
						.no {
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
						}

						.no {
							margin-left: .16rem;
						}

						.details {
							margin-left: .16rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #A88653;
							cursor: pointer;

							.arrow {
								margin-left: .04rem;
								width: .05rem;
								height: .08rem;
							}
						}
					}

					.countdownStatus {
						display: flex;
						align-items: center;

						.countdown {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #252525;

							div {
								margin-left: .02rem;
								margin-right: .02rem;
								width: .22rem;
								height: .22rem;
								background: #E29358;
								border-radius: .04rem;
								line-height: .22rem;
								text-align: center;
								font-weight: 500;
								font-size: .12rem;
								color: #252525;
							}
						}

						.status {
							margin-left: .16rem;
							font-weight: 400;
							font-size: .14rem;
							color: #E29358;
						}
					}
				}

				.orderItemBottom {
					padding: .12rem 0 .24rem;
					display: flex;
					align-items: center;

					.checkImgGoodsInfoBox {
						width: 4rem;
						display: flex;
						align-items: center;

						.checkImg {
							width: .18rem;
							height: .18rem;
						}

						.goodsInfoBox {
							display: flex;
							align-items: center;

							.goodsImg {
								width: 1rem;
								height: 1rem;
								border-radius: .08rem;
								overflow: hidden;
								object-fit: cover;
							}

							.goodsInfo {
								width: 2.4rem;
								margin-left: .16rem;
								display: flex;
								flex-direction: column;

								.goodsTitle {
									font-weight: 700;
									font-size: .16rem;
									color: #000000;
									line-height: .22rem;
								}

								.goodsDesc {
									margin-top: .08rem;
									font-weight: 400;
									font-size: .12rem;
									color: #333333;
									line-height: .16rem;
								}

								.tips {
									margin-top: .12rem;
									display: flex;
									align-items: center;

									.tip {
										height: .26rem;
										padding: 0 .08rem;
										border-radius: .13rem;
										border: .01rem solid #A88653;
										line-height: .24rem;
										font-weight: 400;
										font-size: .12rem;
										color: #7C3E0B;
									}
								}
							}
						}
					}


				}

				.image-gallery {
					width: 3.55rem;
				}

				.operation {
					width: 1.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;

					.download,
					.payNow {
						width: .88rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}

					.apply {
						margin-top: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						cursor: pointer;

						img {
							margin-right: .04rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.cancel {
						margin-top: .12rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
					}

					.delete {
						width: .88rem;
						height: .36rem;
						border-radius: .04rem;
						border: .01rem solid #E29358;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>